// extracted by mini-css-extract-plugin
export default {"container":"BrandReport_container__BwYcI","item":"BrandReport_item__PFUyu"};